import React from 'react';

const FailModal = ({ isOpen, onClose, title = "Error", message, buttonText = "OK" }) => {
  if (!isOpen) return null;

  return (
    <div className="modal modal-blur fade show" id="modal-fail" tabIndex="-1" style={{ display: 'block', background: 'rgba(0, 0, 0, 0.5)' }}>
      <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div className="modal-content">
          <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          <div className="modal-status bg-danger"></div>
          <div className="modal-body text-center py-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="icon mb-2 text-danger icon-lg" width="24" height="24" viewBox="0 0 24 24" 
              strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
              <path d="M12 8l0 4" />
              <path d="M12 16l.01 0" />
            </svg>
            <h3>{title}</h3>
            <div className="text-muted">{message}</div>
          </div>
          <div className="modal-footer">
            <div className="w-100">
              <div className="row">
                <div className="col">
                  <button className="btn w-100" onClick={onClose}>
                    {buttonText}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FailModal; 